import client from '../../../base-api';

const serviceURL = '/analytics/unemployed-overview';

const analyticsUnemployedOverviewService = {

    // Overview
    getPrivateCoachingList(filterData: any) {
        return client.get(`${serviceURL}/private-coaching`, {params: filterData});
    },
    getGroupCoachingList(filterData: any) {
        return client.get(`${serviceURL}/group-coaching`, {params: filterData});
    },
    getSocioTherapyCoachingList(filterData: any) {
        return client.get(`${serviceURL}/socio-therapy-coaching`, {params: filterData});
    },
    getAssistedLivingCoachingList(filterData: any) {
        return client.get(`${serviceURL}/assisted-living-coaching`, {params: filterData});
    },

    getJobCoachingList(filterData: any) {
        return client.get(`${serviceURL}/job-coaching`, {params: filterData});
    },
    getCaseManagementCoachingList(filterData: any) {
        return client.get(`${serviceURL}/case-management-coaching`, {params: filterData});
    },
    getPrivateLearningCoachingList(filterData: any) {
        return client.get(`${serviceURL}/private-learning-coaching`, {params: filterData});
    },
    getOccupationalTherapyCoachingList(filterData: any) {
        return client.get(`${serviceURL}/occupational-therapy-coaching`, {params: filterData});
    },
}

export default analyticsUnemployedOverviewService;